import { actionProps } from "@/lib/controlAnalytics";
import { showingLine } from "@/lib/jobs";
import { leadsOn } from "@/lib/paging";
import type { useCursorPager } from "@/lib/useCursorPager";

const BUTTON =
    "h-8 max-[760px]:min-h-11 rounded-[9px] border border-line-strong bg-card px-3 text-[12px] font-medium text-fg transition-colors hover:bg-hover disabled:border-line disabled:bg-transparent disabled:text-fg-faint disabled:opacity-60";

/** Under the results: which of them these are, and Previous and Next. */
export default function JobsPager({
    pager,
    found,
    total,
    nextCursor,
    stale,
}: {
    pager: ReturnType<typeof useCursorPager>;
    /** How many results this page holds. */
    found: number;
    total: number | undefined;
    nextCursor: string | null | undefined;
    /** Whether the page shown is the last one kept while the next is read. */
    stale: boolean;
}) {
    return (
        <div className="flex items-center justify-between gap-3 px-1 py-1.5 text-[12px] text-fg-muted">
            <span>{showingLine(pager.pageNumber, found, total)}</span>
            <div className="flex gap-1.5">
                <button
                    {...actionProps("job_page_previous_clicked", {
                        source: "Jobs",
                        page_number: pager.pageNumber,
                    })}
                    type="button"
                    disabled={!pager.hasPrevious}
                    onClick={pager.previous}
                    className={BUTTON}
                >
                    Previous
                </button>
                <button
                    {...actionProps("job_page_next_clicked", {
                        source: "Jobs",
                        page_number: pager.pageNumber,
                    })}
                    type="button"
                    disabled={!leadsOn(nextCursor, pager.cursor) || stale}
                    onClick={() => nextCursor && pager.next(nextCursor)}
                    className={BUTTON}
                >
                    Next
                </button>
            </div>
        </div>
    );
}
